"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./TVLaterAlert.scss");
var components_1 = require("@idp/duc/components");
var TVLaterAlert = /** @class */ (function (_super) {
    __extends(TVLaterAlert, _super);
    function TVLaterAlert(props) {
        return _super.call(this, props) || this;
    }
    TVLaterAlert.prototype.render = function () {
        var _a, _b, _c;
        this.userInfoTVLaterMessage = (_a = this.props) === null || _a === void 0 ? void 0 : _a.userInfoTVLaterMessage;
        this.userInfoTVLaterSubMessage = (_b = this.props) === null || _b === void 0 ? void 0 : _b.userInfoTVLaterSubMessage;
        this.userInfoTVLaterPhone = (_c = this.props) === null || _c === void 0 ? void 0 : _c.userInfoTVLaterPhone;
        return (React.createElement("div", { className: styles.mb15, "data-testid": "top-banner" },
            React.createElement(components_1.Alert, { closeable: true, className: "alertStyle pad-xs", testId: "top-banner-alert" },
                React.createElement("div", null,
                    React.createElement("div", { "data-testid": "top-banner-content", className: styles.tvLaterContentStyle },
                        React.createElement("div", null, this.userInfoTVLaterMessage),
                        React.createElement("br", null),
                        React.createElement("div", null,
                            this.userInfoTVLaterSubMessage,
                            React.createElement("span", { className: styles.telephoneLinkStyle },
                                React.createElement("a", { "data-testid": "top-banner-phonenumber", href: "tel://" + this.userInfoTVLaterPhone }, this.userInfoTVLaterPhone))))))));
    };
    return TVLaterAlert;
}(React.Component));
exports.default = TVLaterAlert;
//# sourceMappingURL=TVLaterAlert.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/TVLaterAlert/TVLaterAlert.js
// module id = 798
// module chunks = 8